import React, { memo, useCallback, useState } from "react";
import moment from "moment";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

function DepositCard({ item, userType, reload }) {
  const {
    super_username,
    master_username,
    user_id,
    payment_id,
    amount,
    mime_type,
    base64,
    type,
    msg,
    utr,
    status,
    date_created,
    username,
    success_date,
    reject_date,
    other,
    account_number,
    account_name,
  } = item;

  const [previewVisible, setPreviewVisible] = useState(false);
  const [actionType, setActionType] = useState(null); // "approve" | "reject"
  const [tpassword, setTpassword] = useState("");
  const [loading, setLoading] = useState(false);

  /* ===============================
     🔹 Deposit Slip Preview
  =============================== */

  const handleViewSlip = (e) => {
    e.stopPropagation();
    if (!base64) return toast.error("No deposit slip found!");
    setPreviewVisible(true);
  };

  const openUserEditor = (type) => {
    if (!item) return;
    switch (type) {
      case "super":
        window.user_id = item.super_id;
        window.openeditSuper?.();
        break;
      case "master":
        window.user_id = item.master_id;
        window.masterModalOpen?.();
        break;
      case "user":
        window.user_id = item.user_id;
        window.userModalOpen?.();
        break;
      default:
        break;
    }
  };

  /* ===============================
     🔹 Approve / Reject Logic
  =============================== */

  const handleAction = async () => {
    if (!tpassword) {
      toast.error("Please enter transaction password");
      return;
    }

    try {
      setLoading(true);

      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        user_id: user_id,
        payment_id,
        status: actionType === "approve" ? 1 : 2, // approve | reject
        tpassword,
      };

      const res = await backend.update_deposit_status(data);

      if (res?.error === "False") {
        toast.success(
          actionType === "approve"
            ? "Deposit Approved Successfully"
            : "Deposit Rejected Successfully",
        );
        setActionType(null);
        reload?.();
      } else {
        toast.error(res?.message || "Failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error");
    } finally {
      setLoading(false);
      setTpassword("");
    }
  };

  return (
    <>
      <div className="menuContainer addHight text">
        {/* ---------- ROLE COLUMNS ---------- */}
        {userType === 1 && (
          <div
            onClick={() => openUserEditor("super")}
            className={`menuExchange uppercase pointer `}
          >
            <div className="user_id">{super_username}</div>
          </div>
        )}

        {(userType === 1 || userType === 2) && (
          <div
            onClick={() => openUserEditor("master")}
            className={`menuExchange uppercase pointer small `}
          >
            <div className="user_id">{master_username}</div>
          </div>
        )}
        {(userType === 1 ||
          userType === 2 ||
          userType === 3 ||
          userType === 5 ||
          userType === 6) && (
          <div
            onClick={() => openUserEditor("master")}
            className={`menuExchange uppercase pointer small `}
          >
            <div className="user_id">{master_username}</div>
          </div>
        )}

        {(userType === 1 ||
          userType === 2 ||
          userType === 3 ||
          userType === 5 ||
          userType === 6) && (
          <div className={`menuExchange uppercase pointer small `}>
            {account_number}
          </div>
        )}
        {(userType === 1 ||
          userType === 2 ||
          userType === 3 ||
          userType === 5 ||
          userType === 6) && (
          <div className={`menuExchange uppercase pointer small `}>
            {account_name}
          </div>
        )}

        {/* ID */}
        <div className="menuUsername small">{payment_id}</div>

        {/* Amount */}
        <div className="menuUsername font-semibold">
          ₹ {Number(amount || 0).toLocaleString("en-IN")}
        </div>

        {/* Slip */}
        <div className="menuUsername">
          {type?.toLowerCase() === "deposit" && base64 ? (
            <img
              onClick={handleViewSlip}
              src={`data:${mime_type};base64,${base64}`}
              alt="Slip"
              className="h-8 rounded shadow cursor-pointer"
            />
          ) : (
            "-"
          )}
        </div>

        {/* UTP */}
        <div className={`menuUsername small text-[var(--text)]`}>{utr || "-"}</div>
        {/* MSG */}
        <div
          style={{
            fontSize: 8,
          }}
          className={`menuUsername extraSmall addFlex ${status == 0 ? "text-[var(--text)]" : status == 1 ? "text-[var(--primary)]" : "text-[var(--sell)]"}`}
        >
          {msg || "-"}
        </div>

        <div
          className={`menuUsername flex flex-col items-center justify-center `}
        >
          <div className="extraSmall">
            {success_date ? moment(success_date).format("DD-MM-YYYY") : "-"}
          </div>
          <div className="small">
            {success_date ? moment(success_date).format("HH:mm:ss") : "-"}
          </div>
        </div>

        <div
          className={`menuUsername flex flex-col items-center justify-center `}
        >
          <div className="extraSmall">
            {reject_date ? moment(reject_date).format("DD-MM-YYYY") : "-"}
          </div>
          <div className="small">
            {reject_date ? moment(reject_date).format("HH:mm:ss") : "-"}
          </div>
        </div>

        {/* Date + Time */}
        <div
          className={`menuUsername flex flex-col items-center justify-center `}
        >
          <div className="extraSmall">
            {moment(date_created).format("DD-MM-YYYY")}
          </div>
          <div className="small">{moment(date_created).format("HH:mm:ss")}</div>
        </div>

        {/* OTHERS */}
        <div
          style={{
            fontSize: 8,
          }}
          className={`menuUsername extraSmall text-[var(--text)]`}
        >
          {other || "-"}
        </div>

        {/* ================= ACTION BUTTONS ================= */}
        {status == 0 && (
          <div className="menuUsername addFlex flex gap-2">
            {/* APPROVE */}
            <button
              onClick={() => setActionType("approve")}
              className="bg-green-600 px-2 py-1 text-xs rounded-md text-white"
            >
              ACCEPT
            </button>

            {/* REJECT */}
            <button
              onClick={() => setActionType("reject")}
              className="bg-red-600 px-2 py-1 text-xs rounded-md text-white"
            >
              REJECT
            </button>
          </div>
        )}

        {/* If already processed */}
        {status != 0 && (
          <div className="menuUsername addFlex">
            <span
              className={`px-2 py-1 text-xs rounded-md text-white ${
                status == 1 ? "bg-green-600" : "bg-red-600"
              }`}
            >
              {status == 1 ? "APPROVED" : "REJECTED"}
            </span>
          </div>
        )}
      </div>

      {/* 🔥 Slip Preview */}
      {previewVisible && (
        <div
          onClick={() => setPreviewVisible(false)}
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
        >
          <img
            src={`data:${mime_type};base64,${base64}`}
            alt="Slip"
            className="max-w-[90%] max-h-[90%] rounded-lg"
          />
        </div>
      )}

      {/* 🔥 APPROVE / REJECT PASSWORD MODAL */}
      {actionType && (
        <div className="customModalOverlay" onClick={() => setActionType(null)}>
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">
              {actionType === "approve"
                ? "✅ Approve Deposit"
                : "❌ Reject Deposit"}
            </h3>

            <input
              type="password"
              placeholder="Enter Transaction Password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setActionType(null)}
                disabled={loading}
              >
                Cancel
              </button>

              <button
                className="dropbtnNavSub white primary"
                onClick={handleAction}
                disabled={loading}
              >
                {loading
                  ? "Processing..."
                  : actionType === "approve"
                    ? "Confirm Approve"
                    : "Confirm Reject"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default memo(DepositCard);
